const AUTH_KEY = 'neuro_duel_auth';
import { apiFetch } from '../config';

interface AuthData {
  playerId: number;
  playerName: string;
  token: string;
}

class AuthManager {
  private data: AuthData | null = null;

  constructor() {
    this.load();
  }

  private load() {
    try {
      const raw = localStorage.getItem(AUTH_KEY);
      if (raw) this.data = JSON.parse(raw);
    } catch { this.data = null; }
  }

  private save() {
    try {
      if (this.data) {
        localStorage.setItem(AUTH_KEY, JSON.stringify(this.data));
      } else {
        localStorage.removeItem(AUTH_KEY);
      }
    } catch {}
  }

  isLoggedIn(): boolean {
    return this.data !== null && this.data.playerId > 0;
  }

  getPlayerId(): number {
    return this.data?.playerId || 0;
  }

  getPlayerName(): string {
    return this.data?.playerName || '';
  }

  getToken(): string {
    return this.data?.token || '';
  }

  async login(username: string, password: string): Promise<{ success: boolean; error?: string }> {
    try {
      const res = await apiFetch('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });
      const json = await res.json();
      if (res.ok) {
        this.data = { playerId: json.id, playerName: json.name, token: json.token };
        this.save();
        return { success: true };
      }
      return { success: false, error: json.error || '登录失败' };
    } catch (e: any) {
      console.error('Login error:', e);
      return { success: false, error: `无法连接服务器 (${e?.message || '网络错误'})` };
    }
  }

  async register(username: string, password: string): Promise<{ success: boolean; error?: string }> {
    try {
      const res = await apiFetch('/api/auth/register', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });
      const json = await res.json();
      if (res.ok) {
        this.data = { playerId: json.id, playerName: json.name, token: json.token };
        this.save();
        return { success: true };
      }
      return { success: false, error: json.error || '注册失败' };
    } catch (e: any) {
      console.error('Register error:', e);
      return { success: false, error: `无法连接服务器 (${e?.message || '网络错误'})` };
    }
  }

  async changePassword(oldPassword: string, newPassword: string): Promise<{ success: boolean; error?: string }> {
    if (!this.data) return { success: false, error: '未登录' };
    try {
      const res = await apiFetch('/api/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ username: this.data.playerName, old_password: oldPassword, new_password: newPassword }),
      });
      const json = await res.json();
      if (res.ok) return { success: true };
      return { success: false, error: json.error || '修改失败' };
    } catch (e: any) {
      return { success: false, error: `无法连接服务器 (${e?.message || '网络错误'})` };
    }
  }

  logout() {
    this.data = null;
    localStorage.removeItem(AUTH_KEY);
  }
}

export const authManager = new AuthManager();
